export const SUBSCRIBER_PROVIDER_NAME = 'Assinantes'
export const SUBSCRIBER_IDP = 'assinante'
export const GUEST_PROVIDER_NAME = 'Convidados'
export const REACT_APP_PAGAR_ME_PUBLIC_API = 'pk_test_pyP2np5SPiNQeBKa'
export const TABLET_ZOOM = window.innerWidth / 448